<template>
  <div class="page-container">
    <!-- Topbar -->
    <top-bar title="Supporters"></top-bar>

    <router-view></router-view>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';

export default {
  name: 'Supporter',
  components: {
    TopBar,
  },
};
</script>
